<template>
  <div type="card-full" v-loading="loading">
    <div class="head-title">报价一览表</div>
    <div class="line1"></div>
    <div>
      <div class="view-container">
        <div class="view-box">
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">项目编号</div>
              <div class="view-value">{{ project.projectcode }}</div>
            </div>
            <div class="view-field">
              <div class="view-label">项目名称</div>
              <div class="view-content">{{ project.projectname }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">采购人</div>
              <div class="view-value">{{ project.pcomfullname }}</div>
            </div>
            <div class="view-field" v-if="+project.projecttype === 1">
              <div class="view-label">代理人</div>
              <div class="view-value">{{ project.acomfullname }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">预计开始时间</div>
              <div class="view-value">{{ project.prsbjbegtime | newDateTime }}</div>
            </div>
            <div class="view-field">
              <div class="view-label">预计截止时间</div>
              <div class="view-value">{{ project.prsbjendtime | newDateTime }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">实际开始时间</div>
              <div class="view-value">{{ project.projectjkactualbegtime | newDateTime }}</div>
            </div>
            <div class="view-field">
              <div class="view-label">实际结束时间</div>
              <div class="view-value">{{ project.projectjkactualendtime | newDateTime }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="bjview-box" style="width:100%;">
      <div class="bjview-box" style="margin:0 auto;">
        <div class="bjview-header">
          <div class="bjview-index">
            序号
          </div>
          <div class="bjview-name">
            竞价单位
          </div>
          <div class="bjview-list header-jl">
            报价({{ projectQuotationmodeflg.three }})
          </div>
          <div class="bjview-list-r header-jl-r">
            报价时间
          </div>
          <div class="bjview-name-j">
            报价人
          </div>
        </div>
        <div v-for="(i, index) in ArrList" :key="i.pbrcomid" class="bjview-item">
          <div class="bjview-index">
            <div class="bjview-indexitem">{{ index + 1 }}</div>
          </div>
          <div class="bjview-name">
            <div class="bjview-comname">{{ i.origin[0].pbrcomname }}</div>
          </div>
          <div class="bjview-list">
            <div v-for="j in i.origin" :key="j.pbrid" class="bjview-list-item">
              <div class="item-index">第{{ j.pbtseq }}轮</div>
              <div class="item-price" v-if="+project.projectquotationmode === 1">￥{{ j.pbramt | qfwVal }}元(
                <amount :money="String(j.pbramt)" v-if="j.pbramt" />)
              </div>
              <div class="item-price" v-else>{{ j.pbrpricerate }}%</div>
            </div>
          </div>
          <div class="bjview-list-r">
            <div v-for="j in i.origin" :key="j.pbrid" class="bjview-list-item">
              <div class="item-index">{{ j.pbrtime | newDate }}</div>
            </div>
          </div>
          <!-- <div class="bjview-name-t">
                  {{i.origin[0].psuoffertime}}
                </div> -->
          <div class="bjview-name-j" v-if="$store.getters.loginUser.comtype !==3">
            <div class="bjview-red">
              <!-- <div v-if="+i.origin[0].psuamtcommituserid && +i.origin[0].psuamtcommituserid !== +i.origin[0].psuuserid">
                系统自动确认</div>
              <div v-else> -->
              <div style="text-align:center;">{{ i.origin[0].psuname }}</div>
              <!-- <div>{{i.origin[0].psuamtcommittime | newDateTime}}</div> -->
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getLodop } from '@/assets/js/LodopFuncs'
import { mapGetters } from 'vuex'
import utils from '../../assets/js/utils'
import amount from '../common/amount'
import request from '@/utils/request'
import dayjs from 'dayjs'
// import config from '../../assets/config'
let LODOP
export default {
  name: 'pbrCenterDY',
  filters: {
    newDateTime(val) {
      return utils.formatterDate(val, 'yyyy-MM-dd HH:mm:ss')
    },
    newDate(value) {
      return dayjs(value).format('YYYY-MM-DD HH:mm:ss SSS')
    },
    qfwVal(value) {
      return utils.comdify(value)
    }
  },
  computed: {
    projectQuotationmodeflg() {
      if (+this.project.projectquotationmode === 1) {
        return {
          one: '报价',
          two: '金额报价',
          three: '金额'
        }
      }
      if (+this.project.projectquotationmode === 2) {
        return {
          one: '上浮率报价',
          two: '最高上浮率报价',
          three: '上浮率'
        }
      }
      if (+this.project.projectquotationmode === 3) {
        return {
          one: '下浮率报价',
          two: '最高下浮率报价',
          three: '下浮率'
        }
      }
      if (+this.project.projectquotationmode === 4) {
        return {
          one: '折扣率报价',
          two: '最低折扣率报价',
          three: '折扣率'
        }
      }
      return {
        one: '报价',
        two: '金额报价',
        three: '金额'
      }
    }
  },
  data() {
    return {
      ArrList: [],
      project: {}
    }
  },
  created() {
    this.showbjboxFN()
    this.getModel()
  },
  activated() {
  },
  // deactivated () {
  //   console.log(this.$data)
  //   Object.assign(this.$data, {})
  // },
  components: { amount },
  mounted() {
  },
  methods: {
    async getModel() {
      let res = await request({
        method: 'get',
        url: '/xmgl/project/findProjectById',
        params: { projectid: this.$route.query.projectid }
      })
      this.project = res
    },
    // 获取报价一览表数据
    async showbjboxFN() {
      this.loading = true
      let model = {}
      model.pbrprojectid = this.$route.query.projectid
      let res = await request({
        url: '/xmgl/pbr/getbjList',
        method: "get",
        params: model
      })
      res.map(e => {
        e.psuoffertime = dayjs(e.psuoffertime).format('YYYY-MM-DD HH:mm:ss SSS')
      })
      this.ArrList = this.Sortbycomid(res)
      this.loading = false
    },
    Sortbycomid(beforeData) {
      let tempArr = [], afterData = []
      for (let i = 0; i < beforeData.length; i++) {
        if (tempArr.indexOf(beforeData[i].pbrcomid) === -1) {
          afterData.push({
            pbrcomid: beforeData[i].pbrcomid,
            origin: [beforeData[i]]
          });
          tempArr.push(beforeData[i].pbrcomid);
        } else {
          for (let j = 0; j < afterData.length; j++) {
            if (afterData[j].pbrcomid == beforeData[i].pbrcomid) {
              afterData[j].origin.push(beforeData[i]);
              // afterData[j].origin.sort((a,b) => {
              //   return Number(a.pbramt) - Number(b.pbramt)
              // })
              break;
            }
          }
        }
      }
      return afterData
    },
  }
}
</script>
<style lang="scss" scoped>
.line1 {
  width: 100%;
  height: 1px;
  border-top: 1px solid #000;
  margin: 20px 0;
  background: #000;
}

.head-title {
  font-weight: bold;
  font-size: 26px;
  color: #000;
  margin-top: 20px;
  word-wrap: break-word;
  font-weight: bold;
  text-align: center;

  span {
    font-size: 14px;
  }
}

.bjview-box {
  border-top: 1px solid #000;
  border-left: 1px solid #000;
  border-right: 1px solid #000;
}

.bjview-header {
  display: flex;
  // justify-content: center;
  text-align: center;
  height: 48px;
  line-height: 48px;
  background-color: #f8f8f9;
}

.bjview-index {
  text-align: center;
  width: 50px;
  border-bottom: 1px solid #000;
  border-right: 1px solid #000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bjview-item {
  display: flex;
  line-height: 35px;
}

.view-container {
  font-size: 16px;
}

.view-container .view-box .view-row .view-field .view-value,
.view-container .view-box .view-row .view-field .view-content {
  color: #000;
}

.bjview-name {
  overflow: hidden;
  width: 200px;

  // flex: 1;
  // -webkit-box-flex: 1;
  border-bottom: 1px solid #000;
  border-right: 1px solid #000;

  display: flex;
  justify-content: center;
  align-items: center;
}

.bjview-name-t {
  overflow: hidden;
  width: 200px;

  // flex: 1;
  // -webkit-box-flex: 1;
  border-bottom: 1px solid #000;
  border-right: 1px solid #000;

  display: flex;
  justify-content: center;
  align-items: center;
}

.bjview-name-j {
  overflow: hidden;
  width: 200px;
  border-bottom: 1px solid #000;

  display: flex;
  justify-content: center;
  align-items: center;
}

.bjview-name:last-child {
  border-right: none;
}

.header-jl {
  border-bottom: 1px solid #000;
}

.header-jl-r {
  border-right: 1px solid #000;
}

.bjview-list {
  flex: 5;
  -webkit-box-flex: 5;
  justify-content: space-around;
  box-sizing: border-box;
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  overflow: hidden;
}

.bjview-list-r {
  width: 200px;
  justify-content: space-around;
  box-sizing: border-box;
  // padding: 100px 0 0;
  // border-right: 1px solid #000000;
  border-bottom: 1px solid #000000;
  overflow: hidden;
}

.bjview-list-item {
  display: flex;
  padding-left: 10px;
  white-space: nowrap;
  border-bottom: 1px solid #000;
}

.bjview-list-item:last-child {

  height: 100%;
}

.item-index {
  // width: 150px;
  flex: 2;
  -webkit-box-flex: 1;
  border-right: 1px solid #000;
  text-align: center;
}

.item-price {
  padding-left: 10px;
  // width: 350px;
  flex: 8;
  -webkit-box-flex: 8;
}

.bjview-button {
  width: 100%;
  display: flex;
  justify-content: center;
}

.button-i {
  margin: 30px 0 auto;
  width: 200px;
}

.bjview-red {
  color: red;
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform:translate(-50%,-50%);
}
</style>
